import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Inventory'

// -------

function* getProduct({payload: {id}}) {
  try {
    const route = routePath(Api.product, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getProductSuccess(response));

  } catch (e) {
    return yield put(Actions.getProductFailed(e));
  }
}

function* getFormFilters() {
  try {
    const route = Api.productsFormFilters;
    const response = yield call(axios.get, route);
    yield put(Actions.getFormFiltersSuccess(response));

  } catch (e) {
    return yield put(Actions.getFormFiltersFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  console.log('id', id)
  console.log('values', values)

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.product, { id })

    const response = yield call(axios.post, route, { ...values });
    yield put(Actions.saveFormSuccess(response));

    toast.success('Product has been successfully saved')

  } catch (e) {
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchProductsFormSaga() {
  yield takeLatest(Actions.getProduct.type, getProduct)
  yield takeLatest(Actions.getFormFilters.type, getFormFilters)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchProductsFormSaga
